import { saleBillAddApi } from "../../api/saleBill/saleBillAddApi"

type PayloadShape = Parameters<typeof saleBillAddApi>[0]

export async function saleBillAddService(payload: PayloadShape, token: string) {
	return await saleBillAddApi(payload, token)
}
